import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OccupationalAndDemographicalHistoryData } from '@models/medical-history.model';
import { AlertService } from '@services/alert.service';
import { MedicalHistoryService } from '@services/medical-history.service';
import { take } from 'rxjs';

@Component({
  selector: 'gc-occupation-history',
  templateUrl: './occupational-history.component.html',
  styleUrls: ['./occupational-history.component.scss'],
  standalone: false,
})
export class OccupationalHistoryComponent implements OnInit, OnChanges {
  @Input() userId: number;
  @Input() occupationalAndDemographicalHistoryData: OccupationalAndDemographicalHistoryData;
  @Input() requestUuid: string | null = null;
  @Output() submittedStep = new EventEmitter<{ step: string; values: any }>();

  occupationalAndDemographicalHistoryForm: FormGroup;
  constructor(
    private readonly fb: FormBuilder,
    private readonly medicalHistoryService: MedicalHistoryService,
    private readonly alertService: AlertService,
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['occupationalAndDemographicalHistoryData'] && !changes['occupationalAndDemographicalHistoryData'].firstChange) {
      this.buildForm();
    }
  }

  buildForm() {
    this.occupationalAndDemographicalHistoryForm = this.fb.group({
      occupation: [''],
      note: [''],
    });
    if (this.occupationalAndDemographicalHistoryData) {
      this.occupationalAndDemographicalHistoryForm.setValue(this.occupationalAndDemographicalHistoryData);
    }
  }

  saveToRequest() {
    this.medicalHistoryService
      .saveRequestMedicalHistory$(
        this.requestUuid,
        'occupational_and_demographical_history',
        this.occupationalAndDemographicalHistoryForm.value,
      )
      .pipe(take(1))
      .subscribe((request) => {
        if (request) {
          this.submittedStep.emit({
            step: 'occupationalAndDemographicalHistory',
            values: this.occupationalAndDemographicalHistoryForm.value,
          });
          this.alertService.snackbar('occupational_history_saved');
        }
      });
  }

  saveToProfile(): void {
    this.medicalHistoryService
      .saveMedicalHistory$(this.userId, 'occupational_and_demographical_history', {
        user_id: this.userId,
        occupational_and_demographical_history: this.occupationalAndDemographicalHistoryForm.value,
      })
      .subscribe(() => this.alertService.snackbar('occupational_and_demographical_history_saved'));
  }

  submit() {
    if (this.requestUuid) {
      this.saveToRequest();
    } else {
      this.saveToProfile();
    }
  }
}
